export const POST_CHECKOUT = "POST_CHECKOUT";
export const POST_CHECKOUT_SUCCESS = "POST_CHECKOUT_SUCCESS";
export const POST_CHECKOUT_FAIL = "POST_CHECKOUT_FAIL";